/** What a requirements list should render for a given list state. */
export enum RequirementsListView {
  /** The read has not resolved — stand in a skeleton. */
  Loading = "Loading",
  /** The read resolved and there is genuinely nothing to show. */
  Empty = "Empty",
  /** There are requirements to render. */
  Content = "Content"
}

/**
 * Decides between the skeleton, the empty state and the list.
 *
 * Exists because an unresolved list and an empty one both arrive as
 * `requirements: []`. Every consumer that checked only the length rendered "No
 * requirements active" over a request that had not returned — the whole class of
 * bug this replaces. Loading is checked FIRST, deliberately: a list that is
 * still loading is never empty, however long it happens to be right now.
 *
 * Shared by the three components that render a requirements collection so the
 * ordering cannot drift between them.
 */
export const selectorRequirementsListView = ({
  count,
  isLoading
}: {
  count: number;
  isLoading: boolean;
}): RequirementsListView => {
  if (isLoading) {
    return RequirementsListView.Loading;
  }

  return count === 0
    ? RequirementsListView.Empty
    : RequirementsListView.Content;
};
